import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiDrawer = ({drawer}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => {
  return {
    MuiDrawer: {
      styleOverrides: {
        root: {
          '& .MuiDialogTitle-root': {
            padding: drawer?.container.desktop.padding.all,
            paddingBottom: drawer?.container.desktop.padding.all,
            borderBottom: `${drawer.header.desktop.border.width} ${drawer.header.desktop.border.style} ${drawer.header.desktop.border.color}`,
            [mediaQueries.down('sm')]: {
              padding: drawer?.container.mobile.padding.all
            }
          },
          '& .MuiDialogContent-root': {
            margin: 0,
            padding: drawer?.container.desktop.padding.all,
            [mediaQueries.down('sm')]: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: drawer?.container.mobile.padding.all,
              paddingRight: drawer?.container.mobile.padding.all,
              display: 'flex',
              flexDirection: 'column'
            },
            '& .MuiAlert-message': {
              maxWidth: `calc(100% - 64px)`
            }
          },
          '& .MuiDialogTitle-root+.MuiDialogContent-root': {
            paddingTop: drawer?.container.desktop.padding.all,
            [mediaQueries.down('sm')]: {
              paddingTop: drawer?.container.mobile.padding.all
            }
          },
          '& .MuiDialogActions-root': {
            padding: 24,
            marginTop: 0,
            justifyContent: 'center',
            borderTop: `${drawer.footer.desktop.border.width} ${drawer.footer.desktop.border.style} ${drawer.footer.desktop.border.color}`,
            [mediaQueries.down('sm')]: {
              padding: drawer?.footer.mobile.padding.bottom,
              '> .MuiButtonBase-root': {
                width: '100%'
              }
            }
          }
        },
        paper: {
          borderRadius: drawer?.container.desktop.border.radius.all,
          backgroundColor: drawer?.container.desktop.background.color,
          [mediaQueries.down('sm')]: {
            borderRadius: drawer?.container.mobile.border.radius.all,
            width: drawer?.container.mobile.width
          }
        }
      }
    }
  };
};
